import { gql, useQuery } from '@apollo/client';
import isEmpty from 'lodash/isEmpty';

/* ============================================
   GRAPHQL QUERY DEFINITIONS
   ============================================ */

// Get driver's invite code
const GET_DRIVER_INVITE_CODE = gql`
  query GetDriverInviteCode($driverId: ID!) {
    getDriverInviteCode(driverId: $driverId) {
      id
      code
      driverId
      usageCount
      createdAt
    }
  }
`;

// Look up an invite code (for signup page)
const LOOKUP_INVITE_CODE = gql`
  query LookupInviteCode($code: String!) {
    lookupInviteCode(code: $code) {
      valid
      driverId
      driverName
    }
  }
`;

/* ============================================
   QUERY HOOKS
   ============================================ */

// Get driver's invite code
export const useDriverInviteCode = (driverId) => {
  const {
    data: inviteCodeData,
    loading: loadingInviteCode,
    error: errorInviteCode,
    refetch: refetchInviteCode,
  } = useQuery(GET_DRIVER_INVITE_CODE, {
    variables: { driverId },
    skip: isEmpty(driverId),
  });

  return {
    inviteCodeData,
    loadingInviteCode,
    errorInviteCode,
    refetchInviteCode,
  };
};

// Look up an invite code
export const useLookupInviteCode = (code) => {
  const {
    data: inviteCodeLookupData,
    loading: loadingInviteCodeLookup,
    error: errorInviteCodeLookup,
  } = useQuery(LOOKUP_INVITE_CODE, {
    variables: { code },
    skip: isEmpty(code) || code.length !== 8,
  });

  return {
    inviteCodeLookupData,
    loadingInviteCodeLookup,
    errorInviteCodeLookup,
  };
};
